







































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import {
  InvestmentCustodian,
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import { useUserStore } from "@/shared/store/user";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useNavigationStore } from "@/shared/store/navigation";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

@Component({
  components: {
    ValueBadge
  }
})
export default class Nav extends Vue {
  userStore = useUserStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  navigationStore = useNavigationStore();
  custodianSettingsStore = useCustodianSettingsStore();
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  hsabInvestmentStore = useHsabInvestmentStore();


  afterRoutedHook: any;

  RouteNames = RouteNames;

  @Prop()
  open: boolean;

  navItemActive = "";

  selectNavItem (itemName: string) {
    this.navItemActive = itemName;
  }

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  get isEverythingLoaded () {
    return this.custodianSettingsStore.isLoaded && this.featureFlagStore.featureFlagsAvailable;
  }

  get showDashboardLink (): boolean {
    const { Home, Dashboard } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Home] || this.custodianSettingsStore.disabledRoutes[Dashboard]) {
      return false;
    }

    return true;
  }

  get showCashAccountLink (): boolean {
    const { CashBalance } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[CashBalance]) {
      return false;
    }

    return true;
  }

  get showExpensesLink (): boolean {
    const { HealthcareExpenses } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[HealthcareExpenses]) {
      return false;
    }

    return true;
  }

  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses &&
      this.custodianSettingsStore.showHealthcareExpensesV2;
  }

  get showContributionsLink (): boolean {
    const { Contribution } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Contribution]) {
      return false;
    }

    return true;
  }

  get showContributionPlannerLink (): boolean {
    const { ContributionPlanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ContributionPlanner]) {
      return false;
    }

    return true;
  }

  get showResourcesLink (): boolean {
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    return true;
  }

  get showSettingsLink (): boolean {
    const { Settings } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Settings]) {
      return false;
    }

    return true;
  }

  get settingsUrl (): string {
    if (this.custodianSettingsStore.displaySettingsLinkedAccounts) {
      return "/settings";
    }

    return "/settings/my-profile";
  }

  get showReimburseLink (): boolean {
    return this.custodianSettingsStore.allowReimbursement && !this.bankAccountStore.isBankAccountClosed;
  }

  get userProfileLinkActive () {
    return this.navItemActive === "userProfile";
  }

  get dashboardLinkActive () {
    return this.navItemActive === "dashboard";
  }

  get balancesLinkActive () {
    return this.navItemActive === "balancesActions";
  }

  get healthcareLinkActive () {
    return this.navItemActive === "healthcareExpenses";
  }

  get contributionsLinkActive () {
    return this.navItemActive === "contributions";
  }

  get contributionPlannerLinkActive () {
    return this.navItemActive === "contributionPlanner";
  }

  get investLinkActive () {
    return this.navItemActive === "invest";
  }

  get settingsLinkActive () {
    return this.navItemActive === "settings";
  }

  get resoursesLinkActive () {
    return this.navItemActive === "resources";
  }

  get showInvestmentsLink () {
    if (!this.custodianSettingsStore.displayInvestmentsSection) {
      return false;
    }

    const { InvestmentAccountInfo } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[InvestmentAccountInfo]) {
      return false;
    }

    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      return this.hsabInvestmentStore.hsabInvestmentsEnabled;
    }

    return this.custodianSettingsStore.investmentCustodian !== InvestmentCustodian.Tda
      || this.featureFlagStore.flags.showTdaInvestmentLink;
  }

  created () {
    this.expenseBalanceSummaryStore.loadState();
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getCustodianSettings();
    this.bankAccountStore.getBankAccountStatus();
  }

  beforeDestroy () {
    this.afterRoutedHook();
  }
}

